import type { Meter } from '@weft/types';
import type { Optional } from '@weft/utils';
import { isNotEmptyArray } from '@weft/utils';
import { useMemo } from 'react';

export function useSelectedMeters(metersIds: Optional<string[]>, filterMeters: Meter[], meters: Meter[]) {
  return useMemo(() => (
    isNotEmptyArray(metersIds) && isNotEmptyArray(filterMeters)
      ? filterMeters.filter((item) => metersIds.find((paramId) => paramId === item.id))
      : []
  ), [metersIds, meters]);
}

export function useEventNameMeters(selectedEventNames: Optional<string[]>, meters: Meter[]) {
  return useMemo(() => (
    isNotEmptyArray(selectedEventNames)
      ? filterMetersByEventNames(meters, selectedEventNames)
      : meters
  ), [selectedEventNames, meters]);
}

function filterMetersByEventNames(meters: Meter[], eventNames: string[]) {
  return meters.filter((meter) => eventNames.includes(meter.eventName));
}